
  <div class="empty-data">
    <div class="empty-icon" v-if="showIcon">
      <img :src="imgSrc" alt="empty" />
    </div>
    <div class="empty-text">{{ text }}</div>
  </div>
